
// export const serviceBaseUrl = 'https://usz.ohws.jobbooster.prospective.ch/public/v1';
export const serviceBaseUrl = 'https://ohws.prospective.ch/public/v1';